var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContactDialog',{attrs:{"modal_dialog":_vm.dialog_modal,"standalone":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }